export default {
    staging: {
        apiKey: "AIzaSyCl-GEa6jOITLQOcAuBSqQERIC2XibMnjY",
        authDomain: "dev-app.metatext.ai",
        databaseURL: "https://dev-autonlp.firebaseio.com",
        projectId: "dev-autonlp",
        storageBucket: "dev-autonlp.appspot.com",
        messagingSenderId: "1018727921924",
        appId: "1:1018727921924:web:4d4120d2125557433fb851"
    },
    prod: {
        apiKey: "AIzaSyB6sPH9XEoXxZwfMfGE-fJOVKSljKPsEGk",
        authDomain: "app.metatext.ai",
        databaseURL: "https://ml-saas.firebaseio.com",
        projectId: "ml-saas",
        storageBucket: "ml-saas.appspot.com",
        messagingSenderId: "915060039042",
        appId: "1:915060039042:web:130852640a0f9c737a439b",
        measurementId: "G-G6EW26BLYC"
    }
}